/**
 * Viewer-space units. Every length or size applied in the 3D viewer (crop boxes,
 * zoom padding, tolerances) is in the MODEL's unit: 1 means 1 m in a metre model
 * and 1 mm in a millimetre one. Express sizes in metres and convert here; never
 * hard-code a viewer-unit number.
 *
 * Kept free of the store so it can be unit-tested; coordinateAuthority.js adds
 * the store-reading wrappers.
 */

// Half-size of the crop box the tag and inspection lists draw around a selected tag.
export const TAG_CROP_HALF_SIZE_M = 1;

// Display-unit string → metres per model unit. 0 means "unknown".
export function scaleFromDisplayUnit(unit) {
  switch (unit?.toLowerCase()) {
    case 'm':
      return 1;
    case 'cm':
      return 1 / 100;
    case 'mm':
      return 1 / 1000;
    case 'ft':
      return 1 / 3.28084;
    case 'in':
      return 1 / 39.3701;
    default:
      return 0;
  }
}

/**
 * Metres per viewer unit for the viewer as it is loaded now.
 * The live viewer scale wins: a point-cloud-only viewer runs in metres even when
 * the facility is in millimetres. Before the viewer sets it, fall back to the
 * facility display unit, then the model's own declaration. 0 = unknown.
 */
export function resolveViewerUnitScale({ viewerScale, displayUnit, modelScale } = {}) {
  return viewerScale || scaleFromDisplayUnit(displayUnit) || modelScale || 0;
}

/** Convert metres to viewer units. Throws instead of dividing by 0 or assuming metres. */
export function metresToViewerUnits(metres, scale) {
  if (!Number.isFinite(scale) || scale <= 0) {
    throw new Error('Model units are not loaded for this facility yet. Open the 3D view and try again.');
  }
  return metres / scale;
}
